if (!customElements.get('us-wishlist')) {
  customElements.define('us-wishlist', class extends HTMLElement {
    connectedCallback() {
      this.key = 'uniform-standard-wishlist-v1';
      this.abort = new AbortController();
      this.items = this.read();
      this.list = this.querySelector('[data-wishlist-list]');
      this.status = this.querySelector('[data-wishlist-status]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      document.addEventListener('click', event => {
        const button = event.target.closest('[data-us-wishlist-toggle], [data-wishlist-remove]');
        if (!button) return;
        event.preventDefault();
        const handle = button.dataset.handle;
        if (!/^[a-z0-9-]+$/.test(handle || '')) return;
        const fromDrawer = button.hasAttribute('data-wishlist-remove');
        if (fromDrawer && !this.list.contains(button)) return;
        const index = this.items.findIndex(item => item.handle === handle);
        if (fromDrawer && index === -1) return;
        const removing = index !== -1;
        if (removing) this.items.splice(index, 1);
        else this.items.push({ handle, title: button.dataset.title || handle, image: this.safeImage(button.dataset.image) });
        let message = removing ? this.dataset.removed : this.dataset.added;
        try { localStorage.setItem(this.key, JSON.stringify(this.items)); }
        catch { message = this.dataset.storageError; }
        this.render();
        this.status.textContent = message;
        if (fromDrawer) {
          const buttons = this.list.querySelectorAll('[data-wishlist-remove]');
          const next = buttons[Math.min(index, buttons.length - 1)];
          if (next) next.focus();
          else this.empty.focus();
        }
      }, { signal: this.abort.signal });
      window.addEventListener('storage', event => {
        if (event.key === this.key || event.key === null) { this.items = this.read(); this.render(); }
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.syncButtons());
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.render();
    }
    safeImage(value) {
      try {
        const url = new URL(value, location.origin);
        return url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com') ? url.href : '';
      } catch { return ''; }
    }
    read() {
      try {
        const items = JSON.parse(localStorage.getItem(this.key) || '[]');
        if (!Array.isArray(items)) return [];
        const seen = new Set();
        return items.filter(item => {
          if (!item || !/^[a-z0-9-]+$/.test(item.handle || '') || seen.has(item.handle)) return false;
          seen.add(item.handle);
          return true;
        }).map(item => ({ handle: item.handle, title: String(item.title || item.handle), image: this.safeImage(item.image) }));
      } catch { return []; }
    }
    syncButtons() {
      const saved = new Set(this.items.map(item => item.handle));
      document.querySelectorAll('[data-us-wishlist-toggle]').forEach(button => {
        const active = saved.has(button.dataset.handle);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? this.dataset.remove : this.dataset.add);
      });
    }
    render() {
      this.list.replaceChildren();
      const empty = this.empty;
      empty.hidden = this.items.length > 0;
      empty.tabIndex = -1;
      const root = (this.dataset.root || '/').replace(/\/$/, '') + '/';
      this.items.forEach(item => {
        const row = document.createElement('li');
        const imageLink = document.createElement('a');
        imageLink.href = root + 'products/' + item.handle;
        imageLink.tabIndex = -1;
        imageLink.setAttribute('aria-hidden', 'true');
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 88;
          image.height = 88;
          imageLink.append(image);
        }
        const title = document.createElement('a');
        title.href = imageLink.href;
        title.textContent = item.title;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'us-wishlist-remove';
        remove.dataset.wishlistRemove = '';
        remove.dataset.handle = item.handle;
        remove.setAttribute('aria-label', this.dataset.remove + ': ' + item.title);
        remove.textContent = '×';
        row.append(imageLink, title, remove);
        this.list.append(row);
      });
      this.syncButtons();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
